import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {similarProductsSelector} from "../../ducks/product";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";
import ProductCards from "../../../common/ProductCards";

function SimilarProducts(props) {
  const {similarProducts} = props;
  return (
    <ProductCards title="Рекомендуемые товары" products={similarProducts} />
  );
}

SimilarProducts.propTypes = {
  similarProducts: PropTypes.array
};

const mapStateToProps = (state) => ({
  similarProducts: similarProductsSelector(state)
});

export default connect(mapStateToProps)(withErrorBoundary(SimilarProducts));
